import styled from 'styled-components';

export const Pill = styled.p`
  font-size: 12px;
  line-height: 24px;
  font-family: Mono, sans-serif;
  background-color: ${(props) => props.theme.colors.overlay};
  color: ${(props) => props.theme.colors.disabled};
  display: inline-block;
  padding: 0 8px 0;
  margin-right: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 189px;

  :last-child {
    margin-right: 0;
  }
`;
